import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

// Removes given cookies from the browser session.
// It doesn't work to remove it from ruby/backend, because it needs to
// override the expiration at browser level.
//
// The cookies removed are the ones which name matches `regexName` (given regex) or
// are included in `names` (given string of comma-separated names).
export default class extends Controller {
  static values = {
    names: String, // names separated by comma
    regexName: String, // regexp to match cookie name
    domain: { type: String, default: window.location.hostname },
    path: { type: String, default: "/" }
  }

  initialize() {
    const cookieAttributes = { path: this.pathValue, domain: this.domainValue }

    this.getCookiesNames().forEach((cookieName) => {
      this.deleteCookie(cookieName, cookieAttributes)
    })
  }

  getCookiesNames() {
    if (this.regexNameValue) {
      return document.cookie.split(/; */).
        map((cookiePair) => cookiePair.split("=")[0]).
        filter((cookieName) => cookieName.match(this.regexNameValue))
    } else {
      return this.namesValue.
        split(",").
        map((cookieName) => cookieName.trim())
    }
  }

  deleteCookie(name, attributes) {
    if (Cookies.get(name, attributes)) {
      Cookies.remove(name, attributes)
    }
  }
}
